<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="margin:20px; background:white; border-radius:10px;padding:10px">
          <iframe ref="policyFrame" src="https://api.everythingcheeranddance.com/storage/app/privacy.html" style="width:90%;border:none;height:500px;" />
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from './nav/NavigationBar'
import Store from './HomeStore'
import API from '@/API/API'
import DashboardFooter from './nav/Footer'
import Utils from '../Utils/Utils'
import Navigator from '@/router/navigator'
import AccountSessionUtils from "@/components/account/AccountSessionUtils";
export default {
  name: 'PrivacyPolicy',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      store: Store,
      api: API,
      nav: Navigator,
      accountUtils: AccountSessionUtils
    }
  },
  mounted () {
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
      },
      () => {}
    );

  },
  methods: {


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service-card{
  background: white;
  border-radius: 10px;
  height: 150px;
  overflow:hidden;
}

.orange {
  color:#FF6F5E;
}

.blue {
  color:#192965;
}

.orange-overlay {
  filter: invert(53%) sepia(34%) saturate(887%) hue-rotate(318deg) brightness(98%) contrast(109%);
}

.blue-overlay {
  filter: invert(16%) sepia(14%) saturate(6187%) hue-rotate(205deg) brightness(92%) contrast(100%);
}

p{
  padding-left:10px;
  padding-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue